<template>
  <div class="molecule-comment-section">
    <AtomLabel v-if="showLabel" :for-id="fieldId" :text="labelText" />
    <AtomTextarea
      :id="fieldId"
      :value="value"
      :placeholder="placeholder"
      :disabled="disabled"
      :has-error="hasError"
      :rows="rows"
      :maxlength="maxlength"
      :max-rows="maxRows"
      @input="handleUpdate"
      @blur="handleBlur"
      @focus="handleFocus" />
  </div>
</template>

<script>
  import AtomLabel from "../atoms/AtomLabel.vue";
  import AtomTextarea from "../atoms/AtomTextarea.vue";

  export default {
    name: "MoleculeCommentSection",
    components: {
      AtomLabel,
      AtomTextarea,
    },
    props: {
      label: {
        type: String,
        default: "Comentario",
      },
      placeholder: {
        type: String,
        default: "Escriba su comentario...",
      },
      modelValue: {
        type: String,
        default: "",
      },
      required: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      hasError: {
        type: Boolean,
        default: false,
      },
      rows: {
        type: Number,
        default: 2,
      },
      maxlength: {
        type: Number,
        default: null,
      },
      showLabel: {
        type: Boolean,
        default: true,
      },
      maxRows: {
        type: Number,
        default: null,
      },
    },
    emits: ["input", "blur", "focus"],
    data() {
      return {
        value: this.modelValue,
        uniqueId: Math.random().toString(36).substring(2, 9),
      };
    },
    computed: {
      fieldId() {
        return `comment-${this.uniqueId}`;
      },
      labelText() {
        return this.required ? `${this.label} *` : this.label;
      },
    },
    watch: {
      modelValue(newValue) {
        this.value = newValue;
      },
    },
    methods: {
      handleUpdate(value) {
        this.value = value;
        this.$emit("input", value);
      },
      handleBlur(event) {
        this.$emit("blur", event);
      },
      handleFocus(event) {
        this.$emit("focus", event);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .molecule-comment-section {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 8px;
  }
</style>
